import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {EnvironmentService} from '../../../services/environment.service';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {ApiAgentService} from '../../../services/api-agent.service';
import {GlobalLoaderService} from '../../../services/global-loader.service';
import {MyBusiness} from '../../../models/my-business';
import {Orders} from '../../../models/orders';
import {ProductRequest} from '../../../models/product-request.model';
import * as FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import * as FilePondPluginPdfPreview from '@tofandel/filepond-plugin-pdf-preview';
import {firstValueFrom} from 'rxjs';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {SharePanelComponent} from '../../share-panel/share-panel.component';
import {ProductUpdateComponent} from '../../products/product-update/product-update.component';
import {ProductWidgetComponent} from '../../products/product-widget/product-widget.component';

declare var $: any;
declare var Snackbar: any;
declare var grecaptcha: any;
declare var FilePond: any;
declare var intlTelInput: any;

@Component({
  selector: 'app-order',
  templateUrl: './order.component.html',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, TranslateModule, RouterModule, SharePanelComponent, ProductUpdateComponent, ProductWidgetComponent],
  styleUrls: ['./order.component.scss'],
})
export class OrderComponent implements OnInit {
  @ViewChild('agreementDropzone') agreementDropzoneElm: ElementRef;
  @ViewChild('sendSmsPhoneElm') sendSmsPhoneElm: ElementRef;

  // @ts-ignore
  agreement: any;
  productOrders: ProductRequest[];
  today: any;
  vat: any;
  clientName: any;
  currency: any;
  orderNote: any;
  newOrderNumber: any;
  agreementDropzone: any;
  agreementData: any;
  loading: any;
  loadingBtn: any;
  myBusiness: MyBusiness;
  formStatus: any;
  orderShareLink: any;
  discountType: any;
  sendSmsChecked: any;
  sendSmsPhone: any;
  intlSmsPhoneTelInput: any;
  sendSmsPhoneErrors: [];
  srSvg: any = '<img src="assets/sr.svg" height="18" />';
  srwSvg: any = '<img src="assets/srw.svg" height="18" />';

  constructor(public env: EnvironmentService,
              private translate: TranslateService,
              private loader: GlobalLoaderService,
              private api: ApiAgentService) {
  }

  private _discount: any;

  // @ts-ignore
  get discount() {
    return this._discount ? this._discount : 0;
  }

  // @ts-ignore
  set discount(v) {
    this._discount = v;
  }

  // @ts-ignore
  get subtotal() {
    let subtotal = 0;
    for (let p of this.productOrders) {
      subtotal += p.qty * p.price;
    }

    return subtotal;
  }

  // @ts-ignore
  get total() {

    if (this.discountType == 'SAR') {
      return this.subtotal - this.discount + this.vatAmount;
    } else if (this.discountType == '%') {
      return (this.subtotal * (100 - this.discount) / 100) + this.vatAmount;
    }

  }

  // @ts-ignore
  get vatAmount() {
    if (this.vat) {
      let amount = this.subtotal - this.discount;
      if (this.discountType == '%') {
        amount = this.subtotal * (100 - this.discount) / 100;
      }
      return this.myBusiness.vatPercent * amount;
    } else {
      return 0;
    }
  }

  private static showToast(msg: any) {
    Snackbar.show({
      text: msg,
      pos: 'bottom-center'
    });
  }

  removeProduct(product: any) {
    const index: number = this.productOrders.indexOf(product);
    if (index !== -1) {
      this.productOrders.splice(index, 1);
    }
  }

  async ngOnInit() {
    this.loading = true;
    this.sendSmsChecked = false;

    setTimeout(() => {
      this.intlSmsPhoneTelInput = intlTelInput(this.sendSmsPhoneElm.nativeElement, {
        initialCountry: 'sa',
        separateDialCode: true,
        strictMode: true,
        utilsScript: '/intl-tel-input-utils.js',
      });
    }, 1000);

    await this.loader.loadExternalStyles('/plugins/notification/snackbar/snackbar.min.css');
    await this.loader.loadExternalScript('/plugins/notification/snackbar/snackbar.min.js');

    await this.loader.loadExternalStyles('filepond.css');
    await this.loader.loadExternalScript('filepond.js');
    await this.loader.loadExternalScript('filepond-plugin-file-validate-type.js');
    await this.loader.loadExternalStyles('filepond-plugin-pdf-preview.css');



    this.myBusiness = await this.api.getMyBusiness(false);
    this.newOrder();
    this.loading = false;
    this.discountType = 'SAR'; // 'SAR' for fixed discount. % for percentage discount.
    this.currency = 'SAR';

    FilePond.registerPlugin(FilePondPluginFileValidateType);
    console.log('FilePondPluginFileValidateType', FilePondPluginFileValidateType);
    FilePond.registerPlugin(FilePondPluginPdfPreview);
    console.log('FilePondPluginPdfPreview', FilePondPluginPdfPreview);

    setTimeout(() => {
      this.agreementDropzone = new FilePond.create({
        multiple: false,
        name: 'agreement',
        itemInsertLocation: 'after',
        allowPdfPreview: true,
        pdfPreviewHeight: 320,
        acceptedFileTypes: ['application/pdf'],
      });

      this.agreementDropzone.on('addfile', (error: any, file: any) => {
        if (error) {
          console.log('File upload error:', error);
          return;
        }

        // Successful upload! Here you can:
        // - Access the file object: file
        // - Get base64 data: this.getBase64(file);
        this.getBase64(file).then((data) => {
          console.log('base64', data);
          this.agreementData = data;
        });
        // - Get a byte array: this.getByteArray(file);
        console.log('File added:', file);
      });

      this.agreementDropzoneElm.nativeElement.appendChild(this.agreementDropzone.element);
      console.log('agreementDropzone', this.agreementDropzone);
      this.agreementDropzone.on('success', (file: any, response: any) => {
        console.log('success', response);
        console.log('file', file);
      });
      this.agreementDropzone.on('error', (file: any, response: any) => {
        console.log('error', response);
        console.log('file', file);
      });
      console.log('completed timeout of the init');
    }, 1000);
    console.log('completed the init');
  }

  getBase64(file: any): Promise<any> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file.file); // file.getFile() returns a standard File object
      reader.onload = () => {
        console.log(reader.result); // This will be the base64 string
        resolve(reader.result);
      };
      reader.onerror = () => {
        console.log(reader.error);
        reject(reader.error);
      };
    });
  }

  async submitForm() {
    if (!this.productOrders || this.productOrders.length == 0) {
      OrderComponent.showToast(await firstValueFrom(this.translate.get('Please add products to the invoice')));
    } else if (this.sendSmsChecked && !this.sendSmsPhone) {
      OrderComponent.showToast(await firstValueFrom(this.translate.get('Please enter SMS mobile number.')));
    } else {

      this.loadingBtn = true;
      grecaptcha.ready(() => {
        grecaptcha.execute('6LdJGnQcAAAAAHYu6E0-3HRmRbZbzcs45BBFp_Pu', {action: 'submit'}).then(async (token: any) => {
          try {
            let newOrder: Orders = await this.api.addOrder(this.clientName,
              this.buildProductsData(),
              this.discount,
              this.vat ? this.myBusiness.vatPercent : 0,
              this.orderNote,
              this.discountType,
              this.currency,
              token);

            if (this.agreementData) {
              // Decode base64 string to the byte array
              const byteCharacters = atob(this.agreementData.split(',')[1]);
              const byteNumbers = new Array(byteCharacters.length);
              for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
              }
              const byteArray = new Uint8Array(byteNumbers);

              // Create a blob from the byte array
              const blob = new Blob([byteArray], {type: 'application/pdf'});

              // Convert Blob to File
              const fileName = 'agreement.pdf'; // Define the file name
              const file = new File([blob], fileName, {type: 'application/pdf'});

              // Use your API method to upload the file
              // Ensure this method is adjusted to accept a File object if necessary
              await this.api.postOrderFile(newOrder.orderNumber, file);
            }

            if (this.sendSmsChecked) {
              console.log(this.intlSmsPhoneTelInput);
              await this.api.postSendSmsToOrderClient(newOrder.orderNumber, this.sendSmsPhone, this.intlSmsPhoneTelInput.selectedCountryData.dialCode);
            }

            this.orderShareLink = this.env.getPaymentWebUrl() + '/pay/order/' + newOrder.orderNumber;
            this.newOrderNumber = newOrder.orderNumber;
            this.formStatus = 'created';
          } catch (ex) {
            if (ex.error == null) {
              OrderComponent.showToast(ex);
            } else if (ex.error.detail != null) {
              OrderComponent.showToast(ex.error.detail);
            } else {
              OrderComponent.showToast(ex.error);
            }
          } finally {
            this.loadingBtn = false;
          }
        });
      });
    }
  }

  changeDiscountType(discountType: any) {
    this.discountType = discountType;
  }

  newOrder() {
    this.productOrders = [];
    this.today = new Date().toLocaleDateString('ar', {year: 'numeric', month: 'short', day: 'numeric'});
    this.formStatus = 'new';
    this.clientName = null;
    this.orderNote = null;
    this.newOrderNumber = null;
    this.vat = null;
    this.discount = null;

  }

  shareLink() {
    $('#orderShareLink').modal('show');
  }

  closeModal() {
    $('#addCustomModal').modal('hide');
    $('#addModal').modal('hide');
  }

  productSelected(product: any) {
    console.log('added product', product);
    this.productOrders.push(product);
    this.closeModal();
  }

  private buildProductsData(): ProductRequest[] {
    let productsData: ProductRequest[] = [];
    for (let p of this.productOrders) {
      console.log('product', p);
      productsData.push(this.api.buildProduct(p.id, p.title, p.price, p.price, p.qty));
    }
    return productsData;
  }

  showAddCustomModal() {
    $('#addCustomModal').modal('show');
  }

  showAddProductModal() {
    $('#addModal').modal('show');
  }

  protected readonly close = close;
}
